import { fileDesc, messageDesc, enumDesc } from '@bufbuild/protobuf/codegenv2';
import { file_google_protobuf_wrappers } from '@bufbuild/protobuf/wkt';

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,json_types=true"
// @generated from file sprite.proto (package protosprite, syntax proto3)
/* eslint-disable */
/**
 * Describes the file sprite.proto.
 */
const file_sprite = /*@__PURE__*/ fileDesc("CgxzcHJpdGUucHJvdG8SC3Byb3Rvc3ByaXRlIiAKCFBvc2l0aW9uEgkKAXgYASABKAUSCQoBeRgCIAEoBSIlCgRTaXplEg0KBXdpZHRoGAEgASgFEg4KBmhlaWdodBgCIAEoBSKMAgoFRnJhbWUSDQoFaW5kZXgYASABKAUSLQoGbGF5ZXJzGAIgAygLMh0ucHJvdG9zcHJpdGUuRnJhbWUuRnJhbWVMYXllchIQCghkdXJhdGlvbhgDIAEoAhqyAQoKRnJhbWVMYXllchITCgtsYXllcl9pbmRleBgBIAEoBRIfCgRzaXplGAIgASgLMhEucHJvdG9zcHJpdGUuU2l6ZRItCg5zaGVldF9wb3NpdGlvbhgDIAEoCzIVLnByb3Rvc3ByaXRlLlBvc2l0aW9uEi4KD3Nwcml0ZV9wb3NpdGlvbhgEIAEoCzIVLnByb3Rvc3ByaXRlLlBvc2l0aW9uEg8KB3pfaW5kZXgYBSABKAUiiAEKBUxheWVyEgwKBG5hbWUYASABKAkSEAoIaXNfZ3JvdXAYAiABKAgSMQoMcGFyZW50X2luZGV4GAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLAoHb3BhY2l0eRgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5GbG9hdFZhbHVlIkEKCUFuaW1hdGlvbhIMCgRuYW1lGAEgASgJEhMKC2luZGV4X3N0YXJ0GAIgASgFEhEKCWluZGV4X2VuZBgDIAEoBSKUAQoTRW1iZWRkZWRTcHJpdGVTaGVldBI7CghlbmNvZGluZxgBIAEoDjIpLnByb3Rvc3ByaXRlLkVtYmVkZGVkU3ByaXRlU2hlZXQuRW5jb2RpbmcSDAoEZGF0YRgCIAEoDCIyCghFbmNvZGluZxIUChBFTkNPRElOR19VTktOT1dOEAASEAoMRU5DT0RJTkdfUE5HEAEiQwoTRXh0ZXJuYWxTcHJpdGVTaGVldBINCgN1cmwYAiABKAlIABITCglmaWxlX25hbWUYAyABKAlIAEIICgZzb3VyY2Ui1wIKBlNwcml0ZRIMCgRuYW1lGAEgASgJEiIKGGVtYmVkZGVkX2luX3BhcmVudF9zaGVldBgCIAEoCEgAEjoKDmVtYmVkZGVkX3NoZWV0GAMgASgLMiAucHJvdG9zcHJpdGUuRW1iZWRkZWRTcHJpdGVTaGVldEgAEjoKDmV4dGVybmFsX3NoZWV0GAQgASgLMiAucHJvdG9zcHJpdGUuRXh0ZXJuYWxTcHJpdGVTaGVldEgAEiIKBmZyYW1lcxgFIAMoCzISLnByb3Rvc3ByaXRlLkZyYW1lEiIKBmxheWVycxgGIAMoCzISLnByb3Rvc3ByaXRlLkxheWVyEioKCmFuaW1hdGlvbnMYByADKAsyFi5wcm90b3Nwcml0ZS5BbmltYXRpb24SHwoEc2l6ZRgIIAEoCzIRLnByb3Rvc3ByaXRlLlNpemVCDgoMcGl4ZWxfc291cmNlIrsBCgtTcHJpdGVTaGVldBIkCgdzcHJpdGVzGAEgAygLMhMucHJvdG9zcHJpdGUuU3ByaXRlEjoKDmVtYmVkZGVkX3NoZWV0GAIgASgLMiAucHJvdG9zcHJpdGUuRW1iZWRkZWRTcHJpdGVTaGVldEgAEjoKDmV4dGVybmFsX3NoZWV0GAMgASgLMiAucHJvdG9zcHJpdGUuRXh0ZXJuYWxTcHJpdGVTaGVldEgAQg4KDHBpeGVsX3NvdXJjZWIGcHJvdG8z", [file_google_protobuf_wrappers]);
/**
 * Describes the message protosprite.Position.
 * Use `create(PositionSchema)` to create a new message.
 */
const PositionSchema = /*@__PURE__*/ messageDesc(file_sprite, 0);
/**
 * Describes the message protosprite.Size.
 * Use `create(SizeSchema)` to create a new message.
 */
const SizeSchema = /*@__PURE__*/ messageDesc(file_sprite, 1);
/**
 * Describes the message protosprite.Frame.
 * Use `create(FrameSchema)` to create a new message.
 */
const FrameSchema = /*@__PURE__*/ messageDesc(file_sprite, 2);
/**
 * Describes the message protosprite.Frame.FrameLayer.
 * Use `create(Frame_FrameLayerSchema)` to create a new message.
 */
const Frame_FrameLayerSchema = /*@__PURE__*/ messageDesc(file_sprite, 2, 0);
/**
 * Describes the message protosprite.Layer.
 * Use `create(LayerSchema)` to create a new message.
 */
const LayerSchema = /*@__PURE__*/ messageDesc(file_sprite, 3);
/**
 * Describes the message protosprite.Animation.
 * Use `create(AnimationSchema)` to create a new message.
 */
const AnimationSchema = /*@__PURE__*/ messageDesc(file_sprite, 4);
/**
 * Describes the message protosprite.EmbeddedSpriteSheet.
 * Use `create(EmbeddedSpriteSheetSchema)` to create a new message.
 */
const EmbeddedSpriteSheetSchema = /*@__PURE__*/ messageDesc(file_sprite, 5);
/**
 * @generated from enum protosprite.EmbeddedSpriteSheet.Encoding
 */
var EmbeddedSpriteSheet_Encoding;
(function (EmbeddedSpriteSheet_Encoding) {
    /**
     * @generated from enum value: ENCODING_UNKNOWN = 0;
     */
    EmbeddedSpriteSheet_Encoding[EmbeddedSpriteSheet_Encoding["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: ENCODING_PNG = 1;
     */
    EmbeddedSpriteSheet_Encoding[EmbeddedSpriteSheet_Encoding["PNG"] = 1] = "PNG";
})(EmbeddedSpriteSheet_Encoding = EmbeddedSpriteSheet_Encoding || (EmbeddedSpriteSheet_Encoding = {}));
/**
 * Describes the enum protosprite.EmbeddedSpriteSheet.Encoding.
 */
const EmbeddedSpriteSheet_EncodingSchema = /*@__PURE__*/ enumDesc(file_sprite, 5, 0);
/**
 * Describes the message protosprite.ExternalSpriteSheet.
 * Use `create(ExternalSpriteSheetSchema)` to create a new message.
 */
const ExternalSpriteSheetSchema = /*@__PURE__*/ messageDesc(file_sprite, 6);
/**
 * Describes the message protosprite.Sprite.
 * Use `create(SpriteSchema)` to create a new message.
 */
const SpriteSchema = /*@__PURE__*/ messageDesc(file_sprite, 7);
/**
 * Describes the message protosprite.SpriteSheet.
 * Use `create(SpriteSheetSchema)` to create a new message.
 */
const SpriteSheetSchema = /*@__PURE__*/ messageDesc(file_sprite, 8);

export { AnimationSchema, EmbeddedSpriteSheetSchema, EmbeddedSpriteSheet_Encoding, EmbeddedSpriteSheet_EncodingSchema, ExternalSpriteSheetSchema, FrameSchema, Frame_FrameLayerSchema, LayerSchema, PositionSchema, SizeSchema, SpriteSchema, SpriteSheetSchema, file_sprite };
//# sourceMappingURL=sprite_pb.js.map
